<div class="modal-header">
  <h4 class="modal-title">{{title}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('cancel')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <dl class="row">
    <dt class="col-sm-5 text-right">Appointment time</dt>
    <dd class="col-sm-7">
      {{appointmentRequest.displayedAppointmentDate}}
    </dd>

    <dt class="col-sm-5 text-right">Staff member</dt>
    <dd class="col-sm-7">
      {{appointmentRequest.staffMember}}
    </dd>

    <dt class="col-sm-5 text-right">Location</dt>
    <dd class="col-sm-7">
      {{appointmentRequest.location}}
    </dd>
  </dl>
  <div class="form-group">
    <label for="message">Message</label>
    <div class="form-group">
        <textarea class="form-control" name="message" rows="5"
                  [(ngModel)]="appointmentRequest.message" id="message"
                  [ngClass]="{'is-invalid': errorMessage}"
                  placeholder="Enter message"
        ></textarea>
      <div *ngIf="errorMessage" class="invalid-feedback">
        {{errorMessage}}
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary" (click)="modal.dismiss('cancel')">
    Discard Request
  </button>
  <button type="button" class="btn btn-primary" (click)="submitRequest()">
    Submit Request
  </button>
</div>

